import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useCreateTransactionMutation } from "store/features/transaction/transactionManagementApi";
import { useGetAllClientsQuery } from "store/features/client/clientManagementApi";
import { toast } from "sonner";

const AddTransactionModal = ({ isOpen, toggle, onTransactionCreate }) => {
  const [createTransaction, { isLoading }] = useCreateTransactionMutation();
  const { data: clients = [] } = useGetAllClientsQuery();

  const clientOptions = clients.map((c) => ({
    value: String(c.id),
    label: c.company_name || c.contact_person_name || `Client #${c.id}`,
  }));

  const handleSubmit = async (data) => {
    try {
      const clientId = data.client || clients[0]?.id;
      if (!clientId) {
        toast.error("Please create a Client first before adding a transaction.");
        return;
      }
      const newData = { ...data, client: clientId };
      await createTransaction(newData).unwrap();
      toast.success("Transaction created successfully");
      onTransactionCreate();
    } catch (error) {
      console.error('Transaction creation error:', error);
      toast.error(error?.data?.client?.[0] || "Failed to create transaction");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add New Transaction</ModalHeader>
      <QwikForm onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <div className="mb-3">
                <QwikSelect
                  name="client"
                  label="Select Client"
                  options={clientOptions}
                  placeholder="Select Client"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikSelect
                  name="transaction_type"
                  label="Transaction Type"
                  options={[
                    { value: "deposit", label: "Deposit" },
                    { value: "earning", label: "Earning" },
                    { value: "cost", label: "Cost" }
                  ]}
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="amount"
                  label="Amount"
                  placeholder="Enter amount"
                  type="number"
                  step="0.01"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="date"
                  label="Date"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="description"
                  label="Description"
                  placeholder="Enter transaction description"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Adding..." : "Add Transaction"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default AddTransactionModal;